<div class="form-container">
  <form [formGroup]="bankForm">
    <mat-card>
      <mat-card-content>
        <h4>Bank Details</h4>
        <mat-form-field appearance="fill">
          <mat-label>Bank Code</mat-label>
          <input matInput placeholder="Bank Code" autocomplete="off" formControlName="code" required>
          @if (bankCode.touched && bankCode.invalid && bankCode.hasError('required')) {
            <mat-error>Bank Code is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Bank Name</mat-label>
          <input matInput placeholder="Bank Name" autocomplete="off" formControlName="name" required>
          @if (bankName.touched  && bankName.hasError('required') && bankName.invalid) {
            <mat-error>Bank Name is required</mat-error>
          }
          @if ((bankName.hasError('trimError') || bankName.hasError('pattern')) && bankName.invalid && bankForm.get('name').invalid) {
            <mat-error>Enter valid Bank Name</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Branch Name</mat-label>
          <input matInput placeholder="Branch Name" autocomplete="off" formControlName="branchName" required>
          @if (branchName.touched && branchName.invalid) {
            <mat-error>Branch Name is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>IFSC Code</mat-label>
          <input matInput placeholder="IFSC Code" autocomplete="off" formControlName="ifscCode">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Account No. </mat-label>
          <input matInput placeholder="Account No." autocomplete="off" formControlName="accountNo" required>
          @if (accountNo.touched && accountNo.invalid && accountNo.hasError('pattern')) {
            <mat-error>Enter Valid Account No.</mat-error>
          }
          @if (accountNo.touched && accountNo.invalid && accountNo.hasError('required')) {
            <mat-error>Account No. is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Account Type</mat-label>
          <mat-select formControlName="accountType" required>
            <mat-option [value]="null">None</mat-option>
            @for (type of accountTypes; track type) {
              <mat-option [value]="type.key">
              {{type.label}}</mat-option>
            }
          </mat-select>
          @if (accountType.touched && accountType.invalid && accountType.hasError('required')) {
            <mat-error>Account type is required</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>SWIFT/BIC Code</mat-label>
          <input matInput placeholder="SWIFT/BIC Code" autocomplete="off" formControlName="swiftCode">
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <app-address [addressConfig]="addressConfig" [countryIdFromBank]="countryId"></app-address>
    <mat-card>
      <mat-card-content>
        <h4>Manager Details</h4>
        <mat-form-field appearance="fill">
          <mat-label>Relationship Manager</mat-label>
          <input matInput placeholder="Relationship Manager" autocomplete="off" formControlName="relationshipManager">
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Email Id</mat-label>
          <input matInput placeholder="Email Id" autocomplete="off" formControlName="emailId">
          @if (emailId.hasError('email')) {
            <mat-error>Enter valid Email Id</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Contact No.</mat-label>
          <input matInput placeholder="Contact No." autocomplete="off" formControlName="contactNo">
          @if (contactNo.hasError('pattern')) {
            <mat-error>Enter valid Contact No</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <mat-card-actions>
      <button mat-button color="primary" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
      <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
    </mat-card-actions>
    @if (id) {
      <div class="audit-log">
        <button mat-stroked-button type="button" [class.active]="viewLog.value"
            (click)="viewLog.setValue(!viewLog.value)">
            <mat-icon>history</mat-icon> View Log
        </button>
      </div>
    }
    @if (viewLog.value) {
      <app-history [referenceType]="'BANK'" [referenceId]="id"></app-history>
    }
  </form>
</div>

